import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { TextareaAutosize, Box, Typography, Paper } from "@mui/material";
import {
  StyledBorderDiv,
  StyledFlex,
  StyledSpaceBetween,
} from "../../../Styled";
import {
  handleAttachmentToAi,
  handleGetAiHistory,
  handleQueryToAi,
} from "../../../appStore/actions/ArkchatGroup/action";
import { useTranslation } from "react-i18next";
import AiQuerySend from "../../../common/SvgImageView/AiQuerySend";
import LableToolTip from "../../../common/LableToolTip";
import ChatAddBlack from "../../../assets/images/chat_add_Black.svg";
import useAppSelectors from "../../../customHooks/useAppSelectors";
import filesvg from "../../../assets/images/chats/file_svg.svg";
import { handleChangeTopicOpen } from "../../../appStore/actions/AppState/action";
import { showToastMsg } from "../../../appStore/actions/global/action";
import { generateUniqueId } from "../../../utils/copytoClipboard";
import SelectedAttachmentAiQuery from "../MessageComponent/SelectedAttachmentAiQuery";
import session from "../../../utils/helper";

const AIQueryInputBox = ({
  aiQueryValue,
  setAiQueryValue,
  setTempAiQuery,
  tempAiQuery,
  showTempQuery,
  setShowTempQuery,
  handleClickGoogle,
  handleClickYouTube,
  fileAttachment,
  attachment,
  isTaskUpdateOpen,
  setAttachment,
  setFileAttachment,
  replyParentMsg,
  setReplyParentMsg,
  setisTopicOpen,
  setMoveTopicTriggered,
  isPrivateChatOn,
  selectedTopicToSaveMsg,
  newMessages,
  handleclickAttherate,
  handleMessageSend,


  handelQuery
}) => {
  const { t } = useTranslation();
  const [isAttachmentMenuOpen, setAttachmentMenuOpen] = useState(false);
  const [isFileSectionDisabled, setFileSectionDisabled] = useState(false);
  const [allAttachment, setAllAttachment] = useState([]);
  const appContent = t("AppContent", { returnObjects: true });
  const dispatch = useDispatch();
  const fileRef = useRef(null);
  const menuRef = useRef(null);
  const [isUploading, setIsUploading] = useState(false);
  const { selectedGroup, currentUserData } = useAppSelectors();
  const isThreadScreen = session.get("isThreadScreen");

  useEffect(() => {
    const combinedLength = fileAttachment?.length + attachment?.length;
    const allFilesData = [...fileAttachment, ...attachment];
    setAllAttachment(allFilesData);

    // Setting the disabled state when there's already one attachment
    setFileSectionDisabled(combinedLength >= 1);
  }, [fileAttachment, attachment]);
  useEffect(() => {
    if (fileAttachment.length > 0) {
      handleSendAttachment();
    }
  }, [fileAttachment]);
  const handleChnageQueryInput = (e) => {
    setAiQueryValue(e.target.value);
  };

  const handleFileChange = (e) => {
    setAttachmentMenuOpen(false);
    const file = e.target.files[0]; // Get the single selected file

    if (!file) return;

    // Check if file is PDF
    if (file.type !== "application/pdf") {
      e.preventDefault();
      dispatch(showToastMsg(`Only PDF files are allowed.`));
      return;
    }

    // Check file size (10MB = 10 * 1024 * 1024 bytes)
    const maxSize = 10 * 1024 * 1024; // 10MB in bytes
    if (file.size > maxSize) {
      e.preventDefault();
      dispatch(showToastMsg(`PDF file size must be less than 10MB.`));
      return;
    }

    // Check if there's already an attachment
    if (attachment.length > 0 || fileAttachment.length > 0) {
      e.preventDefault();
      dispatch(showToastMsg(`You can only select one file at a time.`));
      return;
    }

    // Create file object with ID and add directly
    const fileWithId = {
      id: generateUniqueId(file?.name),
      file: file,
    };

    // Update the state with the single file
    setFileAttachment([fileWithId]);

    // Reset the file input
    e.target.value = "";
  };

  // const handleAttachmentMenu = () => {
  //   if (selectedGroup) {
  //     if (setAttachmentMenuOpen) {
  //       setAttachmentMenuOpen(!isAttachmentMenuOpen);
  //     }
  //   }
  // };

  const handleRemoveAttachment = (attachmentId) => {
    // Remove the file with the specified ID from the state
    const updatedattachment = attachment?.filter(
      (file) => file.id !== attachmentId,
    );
    setAttachment(updatedattachment);
    setReplyParentMsg("");
    const updatedFileattachment = fileAttachment?.filter(
      (file) => file.id !== attachmentId,
    );
    setFileAttachment(updatedFileattachment);

    setAllAttachment([...updatedFileattachment, ...updatedattachment]);
  };

  const handleSendAttachment = () => {
    //setTempAiQuery(aiQueryValue);
    // setShowTempQuery(true);
    //setAllAttachment([]);
    //setAiQueryValue("");

    // Set loading state
    setIsUploading(true);

    // Create FormData to match the curl format
    const formData = new FormData();

    // Add the file from fileAttachment (assuming it contains the actual file)
    if (fileAttachment && fileAttachment.length > 0) {
      formData.append("file", fileAttachment[0].file);
    }

    // Add the key (user email)
    formData.append("key", currentUserData?.activeSubscriber?.email);

    dispatch(
      handleAttachmentToAi({
        file: formData,
        key: currentUserData?.activeSubscriber?.email,
      }),
    )
      .then((res) => {
        if (res === 200) {
          // Show success toast message
          const pdfName = fileAttachment[0]?.file?.name || "PDF";
          dispatch(
            showToastMsg(
              `Your ${pdfName} PDF has been successfully uploaded. You can now ask questions related to it.`,
            ),
          );
          // Clear attachments after successful upload

          // dispatch(handleGetAiHistory());

          setFileAttachment([]);
          setAttachment([]);
          setAllAttachment([]);
        }
      })
      .catch((error) => {
        console.error("Error uploading attachment:", error);
      })
      .finally(() => {
        // Reset loading state
        setIsUploading(false);
      });
  };

  const handleSendQuery = () => {
    setFileAttachment([]);
    setAttachment([]);
    setAllAttachment([]);
    setTempAiQuery(aiQueryValue);
    setShowTempQuery(true);
    setAiQueryValue("");
    dispatch(
      handleQueryToAi({
        query: aiQueryValue,
        key: currentUserData?.activeSubscriber?.email,
      }),
    ).then((res) => {
      if (res) {
        setFileAttachment([]);
        setAttachment([]);
        setAllAttachment([]);
        setShowTempQuery(false);
        dispatch(handleGetAiHistory());
      }
    });
  };
  return (
    <>
      <StyledBorderDiv style={{ position: "relative" }}>
        <Box width={"99%"} margin={"auto"}>
          <TextareaAutosize
            sx={{
              "& fieldset": { border: "none" },
            }}
            style={{
              width: "100%",
              resize: "none",
              border: "none",
              outline: "none",
              lineHeight: "1.25rem",
              padding: "5px 8px",
              fontFamily: "Poppins",
              fontSize: "0.87rem",
              overflow: "auto",
            }}
            minRows={"1"}
            placeholder={appContent?.KEY36}
            value={aiQueryValue}
            onChange={handleChnageQueryInput}
          />

          {allAttachment?.length > 0 && !isTaskUpdateOpen && (
            <Box
              width={"100%"}
              position={"relative"}
              height={"3rem"}
              overflow={"scroll"}
              sx={{
                scrollbarWidth: "none",
                "&::-webkit-scrollbar": {
                  width: "1px",
                },
                "&::-webkit-scrollbar-track": {
                  background: "transparent",
                },
                "&::-webkit-scrollbar-thumb": {
                  background: "transparent",
                },
              }}
            >
              <SelectedAttachmentAiQuery
                data={allAttachment}
                handleRemoveAttachment={handleRemoveAttachment}
                replyParentMsg={replyParentMsg}
                isUploading={isUploading}
              />
            </Box>
          )}
          <StyledSpaceBetween
            style={{
              width: "100%",
              marginBottom: "0.4rem",
              alignItems: "center",
            }}
          >
            <input
              type="file"
              accept=".pdf"
              name="file"
              ref={fileRef}
              style={{ display: "none" }}
              onChange={handleFileChange}
            />
            <StyledFlex>
              <>
                {selectedGroup?.isGroup &&
                  isPrivateChatOn &&
                  !isThreadScreen && (
                    <>
                      <Box
                        display={"flex"}
                        alignItems={"center"}
                        justifyContent={"flex-end"}
                        ml={"0.4rem"}
                        maxWidth={"100%"}
                      >
                        <Box
                          display={"flex"}
                          alignItems={"center"}
                          gap={"0.5rem"}
                          justifyContent={"center"}
                        >
                          <Box>
                            <Typography
                              variant="h5"
                              fontSize={"0.7rem"}
                              color={"#00000"}
                              fontWeight={600}
                              mr={"0.5rem"}
                              title={`Topic : ${
                                selectedTopicToSaveMsg
                                  ? selectedTopicToSaveMsg.name
                                  : "General"
                              }`}
                            >
                              {`Topic : ${
                                selectedTopicToSaveMsg
                                  ? selectedTopicToSaveMsg.name.slice(0, 20) +
                                    (selectedTopicToSaveMsg.name?.length > 20
                                      ? " ..."
                                      : "")
                                  : "General"
                              }`}
                            </Typography>
                          </Box>
                        </Box>
                        <Box
                          onClick={() => {
                            setisTopicOpen(true);
                            setMoveTopicTriggered(false);
                            dispatch(handleChangeTopicOpen(true));
                          }}
                          sx={{ cursor: "pointer" }}
                        >
                          <Typography
                            variant="h5"
                            color={"#DB0011"}
                            fontSize={"0.7rem"}
                            fontWeight={600}
                          >
                            Change
                          </Typography>
                        </Box>
                      </Box>
                    </>
                  )}
              </>
            </StyledFlex>
          </StyledSpaceBetween>
        </Box>

        <StyledSpaceBetween
          style={{
            backgroundColor: "#fff",
            display: "flex",
            justifyContent: "space-between",
            width: "99%",
            margin: "auto",
            marginTop: "0.5rem",
          }}
        >
          <Box position={"relative"} width={"30px"} height={"30px"}>
            {isAttachmentMenuOpen && (
              <Box
                ref={menuRef}
                position="absolute"
                top={"-5rem"}
                right={"-10.5rem"}
                width={"12.3rem"}
              >
                <Paper
                  sx={{
                    boxShadow:
                      "rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;",
                    padding: "0.7rem 0rem",
                  }}
                >
                  <Box>
                    <Box
                      p={"0.4rem 1rem"}
                      sx={{
                        cursor: "pointer",
                        pointerEvents: isFileSectionDisabled ? "none" : "",
                      }}
                    >
                      <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                        onClick={() => fileRef.current.click()}
                      >
                        <Box>
                          <Typography>File</Typography>
                          <span
                            style={{ display: "block", fontSize: "0.65rem" }}
                          >
                            {appContent?.KEY304}
                          </span>
                        </Box>
                        <Box>
                          <img src={filesvg} alt="file" />
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                </Paper>
              </Box>
            )}
            {/* <LableToolTip title={appContent?.KEY308}>
              <img
                className="chat-input-icon"
                src={ChatAddBlack}
                alt="attachment"
                onClick={handleAttachmentMenu}
              />
            </LableToolTip> */}
          </Box>

          {aiQueryValue?.trim() && !isUploading && (
            <StyledFlex>
              <Box
                sx={{ cursor: "pointer" }}
                onClick={aiQueryValue ? handelQuery : undefined}
              >
                <AiQuerySend color={aiQueryValue ? null : "#8C8C8C"} />
              </Box>
            </StyledFlex>
          )}
        </StyledSpaceBetween>
      </StyledBorderDiv>
    </>
  );
};

export default AIQueryInputBox;
